export const featuresMap: any = {
  randomization: "randomization",
  randomizationUploadFile: "randomization.upload.file",
  algoRandomization: "algo.randomization",
  // The rebuilt module's child features (randomization spec 14.1). The parent
  // `randomization` flag gates the tab; these two gate the MRT screens and the
  // test bench independently, so a study can randomize without exposing either.
  randomizationMrt: "randomization.mrt",
  randomizationTestbench: "randomization.testbench",
  repeatedData: "repeated.data",
  survey: "survey",
  visit: "visit",
  queries: "queries",
  participantGroups: "participant.groups",
  wearable: "wearable",
  medication: "medication",
  eConsent: "e.consent",
  appointment: "appointments",
  messages: "messages",
  documents: "documents",
  timeline: "timeline",
  milestones: "milestones",
  exercises: "exercises",
  cms: "cms",
  healthParameters: "health.parameters",
  sleep: "sleep",
  bloodGlucose: "blood.glucose",
  bloodPressure: "blood.pressure",
  heartRate: "heart.rate",
  oxygenSaturation: "oxygen.saturation",
  weight: "weight",
  respiratoryRate: "respiratory.rate",
  steps: "steps",
  todo: "todo",
  deviceDetails: "device.details",
  userManual: "user.manual",
};

export const formatFeaturesId = (featuresData: any[]) => {
  const selectedIds: string[] = [];

  featuresData.forEach((feature) => {
    if (feature.selected === "yes") {
      selectedIds.push(feature.id);
    }

    feature.subItems?.forEach((subItem: any) => {
      if (subItem.selected) {
        selectedIds.push(subItem.id);
      }
    });
  });

  return selectedIds;
};

export const computeSelectedState = (subItems: any) => {
  if (!subItems || subItems.length === 0) return "no";

  const allEnabled = subItems.every((subItem: any) => subItem.isEnabled);
  const someEnabled = subItems.some((subItem: any) => subItem.isEnabled);

  if (allEnabled) return "yes";
  if (someEnabled) return "partial";
  return "no";
};
